import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

/**
 * Modal informujący o zakończeniu sesji
 * @component
 */
const SessionWarning = ({
  show = false,
  initialSeconds,
  onExtendSession,
  onTimeout,
}) => {
  const [seconds, setSeconds] = useState(initialSeconds);

  const handleExtendSession = () => {
    onExtendSession();
  };

  useEffect(() => {
    if (show) {
      setSeconds(initialSeconds);
    }
  }, [show, initialSeconds]);

  useEffect(() => {
    if (show && seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((prev) => {
          if (prev <= 1) {
            onTimeout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [show, seconds, onTimeout]);

  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop show z-1"></div>
      <div
        className="modal fade show z-3"
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <i className="bi bi-exclamation-triangle-fill text-danger me-1 fs-2" />
              <h3 className="small-caps me-auto">KONIEC SESJI</h3>
            </div>
            <div className="modal-body text-dark px-2 py-1">
              <p>
                Twoja sesja wygaśnie automatycznie za <strong>{seconds}</strong>{" "}
                sekund
                {(() => {
                  if (seconds === 1) return "ę";
                  if (
                    [2, 3, 4].includes(seconds % 10) &&
                    ![12, 13, 14].includes(seconds % 100)
                  )
                    return "y";
                  return "";
                })()}
                .
              </p>
              <p>Jeśli chcesz kontynuować pracę, kliknij przycisk poniżej.</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary w11"
                onClick={handleExtendSession}
              >
                Przedłuż sesję
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

SessionWarning.propTypes = {
  show: PropTypes.bool,
  initialSeconds: PropTypes.number.isRequired,
  onExtendSession: PropTypes.func.isRequired,
  onTimeout: PropTypes.func.isRequired,
};

SessionWarning.defaultProps = {
  show: false,
  initialSeconds: 30,
};

export default SessionWarning;
